import { supabase } from './supabaseClient';

export const loginUser = async (
  email: string,
  password: string
): Promise<{ ok: boolean; error?: string; errorCode?: string }> => {
  try {
    const normalizedEmail = email.trim().toLowerCase();
    const { data, error } = await supabase.auth.signInWithPassword({ email: normalizedEmail, password });

    if (error) {
      const message = String(error.message || '').toLowerCase();
      const code =
        typeof (error as any).code === 'string' && (error as any).code
          ? (error as any).code
          : message.includes('invalid login credentials')
          ? 'invalid_login_credentials'
          : 'login_failed';

      return { ok: false, error: error.message, errorCode: code };
    }

    const user = data.user;
    if (!user?.email_confirmed_at) {
      await supabase.auth.signOut();
      return {
        ok: false,
        error: 'Please verify your email before logging in.',
        errorCode: 'email_not_verified',
      };
    }

    const token = data.session?.access_token;
    if (!token) {
      return { ok: false, error: 'No session token' };
    }

    const res = await fetch('/api/login-session', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    });

    if (!res.ok) {
      const body = await res.json();
      return { ok: false, error: body.error || 'Failed to set session cookie' };
    }

    await new Promise((r) => setTimeout(r, 100));
    return { ok: true };
  } catch (err: any) {
    return { ok: false, error: err?.message ?? 'Login failed', errorCode: err?.code };
  }
};
